// extracted by mini-css-extract-plugin
module.exports = {"masthead":"Masthead-style__masthead__4a0f200","isTrade":"Masthead-style__isTrade__4a0f200"};